import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class DeleteUserModal extends Component {
  render() {
    const { show, onHide, onConfirm, userName } = this.props;

    return (
      <Modal
        show={show}
        onHide={onHide}
        centered
        className="shadow-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            Are you sure you want to delete {userName ? `user "${userName}"` : 'this user'}? 
            This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="outline-secondary" 
            onClick={onHide}
          >
            Cancel
          </Button>
          <Button 
            variant="danger" 
            onClick={onConfirm}
          >
            Delete User
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DeleteUserModal;